!(function () {
  "use strict";
  var t,
    e = {
      68546: function (t, e, n) {
        n(92222),
          n(91038),
          n(78783),
          n(41539),
          n(54747),
          n(96649),
          n(96078),
          n(82526),
          n(41817),
          n(9653),
          n(69070),
          n(68304),
          n(30489),
          n(12419),
          n(32165),
          n(66992),
          n(33948),
          n(91058);
        var i = "750px",
          r = "1100px",
          o = "1350px",
          a = "1650px",
          c = "2000px",
          s = parseInt("480px"),
          u = parseInt(i),
          l = parseInt(r),
          f = parseInt(o),
          h = parseInt(a),
          p = parseInt(c),
          d = {
            XSMALL: s,
            SMALL: u,
            MEDIUM: l,
            LARGE: f,
            XLARGE: h,
            XXLARGE: p,
          },
          b = "is-open",
          y = "is-initialised",
          m = "has-scroll-overlay";
        function v(t) {
          return (
            (v =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            v(t)
          );
        }
        function g(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, S(i.key), i);
          }
        }
        function S(t) {
          var e = (function (t, e) {
            if ("object" !== v(t) || null === t) return t;
            var n = t[Symbol.toPrimitive];
            if (void 0 !== n) {
              var i = n.call(t, e || "default");
              if ("object" !== v(i)) return i;
              throw new TypeError(
                "@@toPrimitive must return a primitive value."
              );
            }
            return ("string" === e ? String : Number)(t);
          })(t, "string");
          return "symbol" === v(e) ? e : String(e);
        }
        var w = "[data-accordion-title]",
          E = (function () {
            function t(e) {
              var n, i, r;
              !(function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              })(this, t),
                (n = this),
                (r = 400),
                (i = S((i = "animationSpeed"))) in n
                  ? Object.defineProperty(n, i, {
                      value: r,
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                    })
                  : (n[i] = r),
                (this.el = e),
                (this.summary = e.querySelector(w)),
                (this.content = e.querySelector("[data-accordion-body]")),
                (this.animation = null),
                (this.isClosing = !1),
                (this.isExpanding = !1);
            }
            var e, n, i;
            return (
              (e = t),
              (n = [
                {
                  key: "onClick",
                  value: function (t) {
                    t && t.preventDefault(),
                      (this.el.style.overflow = "hidden"),
                      this.isClosing || !this.el.open
                        ? this.open()
                        : (this.isExpanding || this.el.open) && this.shrink();
                  },
                },
                {
                  key: "shrink",
                  value: function () {
                    var t = this;
                    if (this.summary) {
                      this.isClosing = !0;
                      var e = "".concat(this.el.offsetHeight, "px"),
                        n = "".concat(this.summary.offsetHeight, "px");
                      this.animation && this.animation.cancel(),
                        (this.animation = this.el.animate(
                          { height: [e, n] },
                          { duration: this.animationSpeed, easing: "ease-out" }
                        )),
                        (this.animation.onfinish = function () {
                          return t.onAnimationFinish(!1);
                        }),
                        (this.animation.oncancel = function () {
                          return (t.isClosing = !1);
                        });
                    }
                  },
                },
                {
                  key: "open",
                  value: function () {
                    var t = this;
                    console.log("open");

                    (this.el.style.height = "".concat(
                      this.el.offsetHeight,
                      "px"
                    )),
                      (this.el.open = !0),
                      window.requestAnimationFrame(function () {
                        return t.expand();
                      });
                  },
                },
                {
                  key: "expand",
                  value: function () {
                    var t = this;
                    if (this.summary && this.content) {
                      this.isExpanding = !0;
                      var e = "".concat(this.el.offsetHeight, "px"),
                        n = "".concat(
                          this.summary.offsetHeight + this.content.offsetHeight,
                          "px"
                        );
                      this.animation && this.animation.cancel(),
                        (this.animation = this.el.animate(
                          { height: [e, n] },
                          { duration: this.animationSpeed, easing: "ease-out" }
                        )),
                        (this.animation.onfinish = function () {
                          return t.onAnimationFinish(!0);
                        }),
                        (this.animation.oncancel = function () {
                          return (t.isExpanding = !1);
                        });
                    }
                  },
                },
                {
                  key: "onAnimationFinish",
                  value: function (t) {
                    (this.el.open = t),
                      (this.animation = null),
                      (this.isClosing = !1),
                      (this.isExpanding = !1),
                      (this.el.style.height = this.el.style.overflow = "");
                  },
                },
              ]) && g(e.prototype, n),
              i && g(e, i),
              Object.defineProperty(e, "prototype", { writable: !1 }),
              t
            );
          })();
        function k(t) {
          return (
            (k =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            k(t)
          );
        }
        function O(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, j(i.key), i);
          }
        }
        function x(t, e, n) {
          return (
            (e = j(e)) in t
              ? Object.defineProperty(t, e, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (t[e] = n),
            t
          );
        }
        function j(t) {
          var e = (function (t, e) {
            if ("object" !== k(t) || null === t) return t;
            var n = t[Symbol.toPrimitive];
            if (void 0 !== n) {
              var i = n.call(t, e || "default");
              if ("object" !== k(i)) return i;
              throw new TypeError(
                "@@toPrimitive must return a primitive value."
              );
            }
            return ("string" === e ? String : Number)(t);
          })(t, "string");
          return "symbol" === k(e) ? e : String(e);
        }
        var A = (function () {
            function t(e, n) {
              !(function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              })(this, t),
                x(this, "accordionSlideElements", null),
                x(this, "accordionSlides", []),
                x(this, "disableSize", null),
                (this.container = e),
                (this.accordionSlideElements = Array.from(
                  e.querySelectorAll("[data-accordion-slide]")
                )),
                n && (this.disableSize = n),
                this.attachEvents();
            }
            var e, n, i;
            return (
              (e = t),
              (n = [
                {
                  key: "openAccordion",
                  value: function () {
                    this.accordionSlideElements &&
                      (this.container.classList.contains(b) ||
                        (this.container.classList.add(b),
                        this.accordionSlideElements.forEach(function (t) {
                          return t.setAttribute("open", "open");
                        })));
                  },
                },
                {
                  key: "closeAccordion",
                  value: function () {
                    this.accordionSlideElements &&
                      this.container.classList.contains(b) &&
                      (this.container.classList.remove(b),
                      this.accordionSlideElements.forEach(function (t) {
                        return t.removeAttribute("open");
                      }));
                  },
                },
                {
                  key: "closeActiveSlides",
                  value: function (t, e) {
                    this.accordionSlides &&
                      0 != this.accordionSlides.length &&
                      this.accordionSlides.forEach(function (n) {
                        n.el != e && n.el.open && n.onClick(t);
                      });
                  },
                },
                {
                  key: "onCLick",
                  value: function (t, e) {
                    if (
                      this.accordionSlides &&
                      0 != this.accordionSlides.length &&
                      !(
                        this.disableSize &&
                        ((n = this.disableSize), window.innerWidth >= d[n])
                      )
                    ) {
                      var n,
                        i = this.accordionSlides[e];
                      i && (this.closeActiveSlides(t, i.el), i.onClick(t));
                    }
                  },
                },
                {
                  key: "attachEvents",
                  value: function () {
                    var t = this;
                    this.accordionSlideElements &&
                      this.accordionSlideElements.length > 0 &&
                      this.accordionSlideElements.forEach(function (e, n) {
                        var i = new E(e);
                        t.accordionSlides.push(i);
                        var r = e.querySelector(w);
                        r &&
                          r.addEventListener("click", function (e) {
                            return t.onCLick(e, n);
                          });
                      });
                  },
                },
                {
                  key: "detachEvents",
                  value: function () {
                    var t = this;
                    this.accordionSlideElements &&
                      this.accordionSlideElements.length > 0 &&
                      this.accordionSlideElements.forEach(function (e, n) {
                        var i = e.querySelector(w);
                        i &&
                          i.removeEventListener("click", function (e) {
                            return t.onCLick(e, n);
                          });
                      });
                  },
                },
              ]) && O(e.prototype, n),
              i && O(e, i),
              Object.defineProperty(e, "prototype", { writable: !1 }),
              t
            );
          })(),
          L =
            (n(88674),
            n(82772),
            n(39714),
            n(51532),
            n(10072),
            n(99137),
            n(71957),
            n(96306),
            n(103),
            n(74592),
            n(58276),
            n(35082),
            n(12813),
            n(18222),
            n(38563),
            n(50336),
            n(7512),
            n(27852),
            n(54678),
            n(47941),
            n(57327),
            n(38880),
            n(49337),
            n(33321),
            {
              short: ".2s",
              med: ".6s",
              slow: "1s",
              timeDefault: ".2s",
              easeIn: "cubic-bezier(.7,0,.84,0)",
              easeOut: "cubic-bezier(.16,1,.3,1)",
              easeInOut: "cubic-bezier(.87,0,.13,1)",
            });
        function P(t) {
          return (
            (P =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            P(t)
          );
        }
        function C(t, e) {
          var n = Object.keys(t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(t);
            e &&
              (i = i.filter(function (e) {
                return Object.getOwnPropertyDescriptor(t, e).enumerable;
              })),
              n.push.apply(n, i);
          }
          return n;
        }
        function T(t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = null != arguments[e] ? arguments[e] : {};
            e % 2
              ? C(Object(n), !0).forEach(function (e) {
                  q(t, e, n[e]);
                })
              : Object.getOwnPropertyDescriptors
              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
              : C(Object(n)).forEach(function (e) {
                  Object.defineProperty(
                    t,
                    e,
                    Object.getOwnPropertyDescriptor(n, e)
                  );
                });
          }
          return t;
        }
        function q(t, e, n) {
          return (
            (e = (function (t) {
              var e = (function (t, e) {
                if ("object" !== P(t) || null === t) return t;
                var n = t[Symbol.toPrimitive];
                if (void 0 !== n) {
                  var i = n.call(t, e || "default");
                  if ("object" !== P(i)) return i;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return ("string" === e ? String : Number)(t);
              })(t, "string");
              return "symbol" === P(e) ? e : String(e);
            })(e)) in t
              ? Object.defineProperty(t, e, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (t[e] = n),
            t
          );
        }
        var z = function (t) {
            return t.endsWith("ms")
              ? parseFloat(t)
              : t.endsWith("s")
              ? 1e3 * parseFloat(t)
              : 200;
          },
          _ = T(
            T({}, L),
            {},
            {
              durationDefault: z(L.timeDefault),
              durationMedium: z(L.med),
              durationShort: z(L.short),
              durationSlow: z(L.slow),
            }
          );
        n(21249), n(47042), n(74916);
        function D(t) {
          return (
            (D =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            D(t)
          );
        }
        function B(t) {
          return (
            (function (t) {
              if (Array.isArray(t)) return M(t);
            })(t) ||
            (function (t) {
              if (
                ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
                null != t["@@iterator"]
              )
                return Array.from(t);
            })(t) ||
            (function (t, e) {
              if (!t) return;
              if ("string" == typeof t) return M(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              "Object" === n && t.constructor && (n = t.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(t);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return M(t, e);
            })(t) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }
        function M(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
          return i;
        }
        var R = function (t, e) {
          if (
            t.target &&
            (t.target instanceof HTMLElement ||
              t.target instanceof SVGElement) &&
            "undefined" !== D(t.target.matches)
          )
            return t.target.matches(e) ? t.target : t.target.closest(e);
        };
        function H(t) {
          return (
            (H =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            H(t)
          );
        }
        function I(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, K(i.key), i);
          }
        }
        function F(t) {
          var e = G();
          return function () {
            var n,
              i = U(t);
            if (e) {
              var r = U(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return (function (t, e) {
              if (e && ("object" === H(e) || "function" == typeof e)) return e;
              if (void 0 !== e)
                throw new TypeError(
                  "Derived constructors may only return object or undefined"
                );
              return N(t);
            })(this, n);
          };
        }
        function N(t) {
          if (void 0 === t)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return t;
        }
        function V(t) {
          var e = "function" == typeof Map ? new Map() : void 0;
          return (
            (V = function (t) {
              if (
                null === t ||
                ((n = t),
                -1 === Function.toString.call(n).indexOf("[native code]"))
              )
                return t;
              var n;
              if ("function" != typeof t)
                throw new TypeError(
                  "Super expression must either be null or a function"
                );
              if (void 0 !== e) {
                if (e.has(t)) return e.get(t);
                e.set(t, i);
              }
              function i() {
                return W(t, arguments, U(this).constructor);
              }
              return (
                (i.prototype = Object.create(t.prototype, {
                  constructor: {
                    value: i,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0,
                  },
                })),
                X(i, t)
              );
            }),
            V(t)
          );
        }
        function W(t, e, n) {
          return (
            (W = G()
              ? Reflect.construct.bind()
              : function (t, e, n) {
                  var i = [null];
                  i.push.apply(i, e);
                  var r = new (Function.bind.apply(t, i))();
                  return n && X(r, n.prototype), r;
                }),
            W.apply(null, arguments)
          );
        }
        function G() {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;
          try {
            return (
              Boolean.prototype.valueOf.call(
                Reflect.construct(Boolean, [], function () {})
              ),
              !0
            );
          } catch (t) {
            return !1;
          }
        }
        function X(t, e) {
          return (
            (X = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return (t.__proto__ = e), t;
                }),
            X(t, e)
          );
        }
        function U(t) {
          return (
            (U = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            U(t)
          );
        }
        function Y(t, e, n) {
          return (
            (e = K(e)) in t
              ? Object.defineProperty(t, e, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (t[e] = n),
            t
          );
        }
        function K(t) {
          var e = (function (t, e) {
            if ("object" !== H(t) || null === t) return t;
            var n = t[Symbol.toPrimitive];
            if (void 0 !== n) {
              var i = n.call(t, e || "default");
              if ("object" !== H(i)) return i;
              throw new TypeError(
                "@@toPrimitive must return a primitive value."
              );
            }
            return ("string" === e ? String : Number)(t);
          })(t, "string");
          return "symbol" === H(e) ? e : String(e);
        }
        var $ = "is-light-box-open",
          J = document.createElement("template");
        J.innerHTML =
          "\n  <style>\n    * { box-sizing: border-box; }\n\n    .container {\n      display: none;\n      justify-content: stretch;\n      align-items: stretch;\n    }\n\n    .background {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      transition: all "
            .concat(_.timeDefault, " ")
            .concat(
              _.easeOut,
              ";\n    }\n\n    .wrapper {\n      position: fixed;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 1;\n      overflow-y: auto;\n    }\n\n    .inner {\n      padding: 1.25rem;\n      width: 100%;\n      min-height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .popup {\n      box-sizing: border-box;\n      position: relative;\n      width: 100%;\n      max-width: 87.5rem;\n      padding: 2rem 0;\n\n      opacity: 0;\n      transform: translateY(-2rem);\n      transition: all "
            )
            .concat(_.timeDefault, " ")
            .concat(
              _.easeOut,
              ';\n    }\n\n    .popup.small { max-width: 30rem; }\n    .popup.large { max-width: 80rem; }\n    .container.is-visible { display: block; }\n\n    .is-closing .popup { transform: translateY(2rem); }\n    .is-open .background { opacity: 1; }\n    .is-open .popup {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  </style>\n\n  <div part="root" class="container">\n    <div part="background" class="background"></div>\n    <div part="wrapper" class="wrapper">\n      <div part="inner" class="inner">\n        <div part="popup" class="popup">\n          <slot></slot>\n        </div>\n      </div>\n    </div>\n  </div>\n'
            );
        var Q = (function (t) {
          !(function (t, e) {
            if ("function" != typeof e && null !== e)
              throw new TypeError(
                "Super expression must either be null or a function"
              );
            (t.prototype = Object.create(e && e.prototype, {
              constructor: { value: t, writable: !0, configurable: !0 },
            })),
              Object.defineProperty(t, "prototype", { writable: !1 }),
              e && X(t, e);
          })(o, t);
          var e,
            n,
            i,
            r = F(o);
          function o() {
            var t;
            !(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, o),
              Y(N((t = r.call(this))), "videos", null),
              Y(N(t), "onKeyPress", function (e) {
                var n;
                t.closable &&
                  "Escape" == e.key &&
                  ((t.visible = !1),
                  null === (n = t.videos) ||
                    void 0 === n ||
                    n.forEach(function (t) {
                      return t.pause();
                    }));
              }),
              Y(N(t), "onBackgroundClick", function (e) {
                var n;
                e.target === t.inner &&
                  (t.closable && (t.visible = !1),
                  null === (n = t.videos) ||
                    void 0 === n ||
                    n.forEach(function (t) {
                      return t.pause();
                    }));
              }),
              Y(N(t), "onDocumentClick", function (e, n) {
                var i = n.getAttribute("data-light-box-trigger");
                i &&
                  t.matches(i) &&
                  (e.preventDefault(), (t.visible = !t.closable || !t.visible));
              }),
              (t.timeout = null);
            var e = t.attachShadow({ mode: "open" });
            return (
              e.appendChild(J.content.cloneNode(!0)),
              (t.root = e.querySelector(".container")),
              (t.inner = e.querySelector(".inner")),
              (t.popup = e.querySelector(".popup")),
              (t.parent = t.parentElement || null),
              (t.videos = Array.from(t.querySelectorAll("[data-video]"))),
              document.addEventListener("keydown", t.onKeyPress),
              (function (t) {
                var e = t.element,
                  n = t.selector,
                  i = t.event,
                  r = t.callback,
                  o = t.events,
                  a = function (t) {
                    var e = R(t, n);
                    e && r(t, e);
                  },
                  c =
                    "string" == typeof e
                      ? document.querySelector(e)
                      : e.documentElement
                      ? e.documentElement
                      : e;
                if (!c) return null;
                var s = [];
                i && s.push(i),
                  o && s.push.apply(s, B(o)),
                  s.map(function (t) {
                    return c.addEventListener(t, a);
                  });
              })({
                callback: t.onDocumentClick,
                selector: "[data-light-box-trigger]",
                element: document,
                event: "click",
              }),
              t.inner.addEventListener("click", t.onBackgroundClick),
              t.updateVisible(),
              t
            );
          }
          return (
            (e = o),
            (i = [
              {
                key: "observedAttributes",
                get: function () {
                  return ["visible", "closable", "size"];
                },
              },
            ]),
            (n = [
              {
                key: "visible",
                get: function () {
                  return "true" == this.getAttribute("visible");
                },
                set: function (t) {
                  this.setAttribute("visible", t + ""), this.updateVisible();
                },
              },
              {
                key: "closable",
                get: function () {
                  return (
                    !this.hasAttribute("closable") ||
                    "true" == this.getAttribute("closable")
                  );
                },
                set: function (t) {
                  this.setAttribute("closable", t + "");
                },
              },
              {
                key: "size",
                get: function () {
                  return this.getAttribute("size") || "medium";
                },
                set: function (t) {
                  this.setAttribute("size", t), this.updateSize();
                },
              },
              {
                key: "padded",
                get: function () {
                  return (
                    !this.hasAttribute("padded") ||
                    "true" == this.getAttribute("padded")
                  );
                },
                set: function (t) {
                  this.setAttribute("padded", t + ""), this.updatePadded();
                },
              },
              {
                key: "updateVisible",
                value: function () {
                  var t = this;
                  this.timeout && clearTimeout(this.timeout),
                    this.visible
                      ? (document.body.classList.add($),
                        this.root.classList.add("is-visible"),
                        this.root.classList.remove("is-closing"),
                        document.body.appendChild(this),
                        (this.timeout = setTimeout(function () {
                          return t.root.classList.add("is-open");
                        }, 16)),
                        this.root.part.add("visible"))
                      : (document.body.classList.remove($),
                        (this.parent || document.body).appendChild(this),
                        setTimeout(function () {
                          t.root.classList.remove("is-open"),
                            t.root.classList.add("is-closing");
                        }, 16),
                        (this.timeout = setTimeout(function () {
                          t.root.classList.remove("is-visible"),
                            t.root.classList.remove("is-closing");
                        }, _.durationDefault)),
                        this.root.part.remove("visible"));
                },
              },
              {
                key: "updateSize",
                value: function () {
                  switch (
                    (this.popup.classList.remove("small"),
                    this.popup.classList.remove("large"),
                    this.size)
                  ) {
                    case "small":
                      this.popup.classList.add("small");
                      break;
                    case "large":
                      this.popup.classList.add("large");
                  }
                },
              },
              {
                key: "updatePadded",
                value: function () {
                  this.padded
                    ? this.popup.part.remove("unpadded")
                    : this.popup.part.add("unpadded");
                },
              },
              {
                key: "attributeChangedCallback",
                value: function (t, e, n) {
                  switch (t) {
                    case "visible":
                      this.updateVisible();
                      break;
                    case "size":
                      this.updateSize();
                      break;
                    case "padded":
                      this.updatePadded();
                  }
                },
              },
            ]) && I(e.prototype, n),
            i && I(e, i),
            Object.defineProperty(e, "prototype", { writable: !1 }),
            o
          );
        })(V(HTMLElement));
        Y(Q, "confirm", function (t) {
          var e = new Q();
          document.body.appendChild(e),
            e.classList.add("o-light-box__confirm"),
            (e.size = "small");
          var n = document.createElement("div");
          n.classList.add("o-light-box__buttons");
          var i = document.createElement("button");
          (i.type = "button"),
            i.classList.add("o-btn"),
            (i.textContent = t.yes);
          var r = document.createElement("button");
          (r.type = "button"), r.classList.add("o-btn"), (r.textContent = t.no);
          var o = document.createElement("h2");
          (o.textContent = t.title),
            e.appendChild(o),
            e.appendChild(n),
            n.appendChild(i),
            n.appendChild(r),
            (e.visible = !0);
          var a = function () {
            (i.disabled = !0),
              i.classList.add("is-disabled"),
              (r.disabled = !0),
              r.classList.add("is-disabled"),
              (e.visible = !1),
              setTimeout(function () {
                return e.remove();
              }, _.durationDefault);
          };
          return new Promise(function (t, e) {
            i.addEventListener("click", function () {
              t(!0), a();
            }),
              r.addEventListener("click", function () {
                t(!1), a();
              });
          });
        }),
          customElements.get("light-box") ||
            customElements.define("light-box", Q);
        n(34553), n(15306);
        function Z(t) {
          return (
            (Z =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            Z(t)
          );
        }
        function tt(t, e) {
          return (
            (function (t) {
              if (Array.isArray(t)) return t;
            })(t) ||
            (function (t, e) {
              var n =
                null == t
                  ? null
                  : ("undefined" != typeof Symbol && t[Symbol.iterator]) ||
                    t["@@iterator"];
              if (null != n) {
                var i,
                  r,
                  o,
                  a,
                  c = [],
                  s = !0,
                  u = !1;
                try {
                  if (((o = (n = n.call(t)).next), 0 === e)) {
                    if (Object(n) !== n) return;
                    s = !1;
                  } else
                    for (
                      ;
                      !(s = (i = o.call(n)).done) &&
                      (c.push(i.value), c.length !== e);
                      s = !0
                    );
                } catch (t) {
                  (u = !0), (r = t);
                } finally {
                  try {
                    if (
                      !s &&
                      null != n.return &&
                      ((a = n.return()), Object(a) !== a)
                    )
                      return;
                  } finally {
                    if (u) throw r;
                  }
                }
                return c;
              }
            })(t, e) ||
            (function (t, e) {
              if (!t) return;
              if ("string" == typeof t) return et(t, e);
              var n = Object.prototype.toString.call(t).slice(8, -1);
              "Object" === n && t.constructor && (n = t.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(t);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return et(t, e);
            })(t, e) ||
            (function () {
              throw new TypeError(
                "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
              );
            })()
          );
        }
        function et(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
          return i;
        }
        function nt(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, rt(i.key), i);
          }
        }
        function it(t, e, n) {
          return (
            (e = rt(e)) in t
              ? Object.defineProperty(t, e, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (t[e] = n),
            t
          );
        }
        function rt(t) {
          var e = (function (t, e) {
            if ("object" !== Z(t) || null === t) return t;
            var n = t[Symbol.toPrimitive];
            if (void 0 !== n) {
              var i = n.call(t, e || "default");
              if ("object" !== Z(i)) return i;
              throw new TypeError(
                "@@toPrimitive must return a primitive value."
              );
            }
            return ("string" === e ? String : Number)(t);
          })(t, "string");
          return "symbol" === Z(e) ? e : String(e);
        }
        var ot = "data-section-initialized",
          at = (function () {
            function t(e, n) {
              var i = this;
              if (
                ((function (t, e) {
                  if (!(t instanceof e))
                    throw new TypeError("Cannot call a class as a function");
                })(this, t),
                it(this, "onInnerHtmlMutationObserved", function (e, n) {
                  if (e.length && i.shopifyContainer) {
                    var r = tt(e, 1)[0],
                      o = [];
                    r.removedNodes.forEach(function (t) {
                      return o.push(t);
                    }),
                      -1 !==
                        o.findIndex(function (t) {
                          return t === i.shopifyContainer;
                        }) &&
                        (console.log("Section", i.id, "reloaded."),
                        i.dispose(),
                        t.recheck(i.selector));
                  }
                }),
                (this.container = e),
                (this.selector = n),
                this.container.setAttribute(ot, "true"),
                (this.shopifyContainer = this.container.parentElement),
                this.shopifyContainer && this.shopifyContainer.id)
              )
                try {
                  this.id = this.shopifyContainer.id.replace(
                    /shopify-section-/,
                    ""
                  );
                } catch (t) {
                  console.warn(t);
                }
              this.innerHtmlObserver = null;
            }
            var e, n, i;
            return (
              (e = t),
              (i = [
                {
                  key: "register",
                  value: function (e, n) {
                    var i = [];
                    return (
                      document.querySelectorAll(e).forEach(function (r) {
                        if (!t.isRegistered(r)) {
                          var o = new n(r, e);
                          i.push(o),
                            o.queryChildren(r),
                            o.init(),
                            o.attachEvents(r);
                        }
                      }),
                      (this.registrations[e] = n),
                      i
                    );
                  },
                },
                {
                  key: "recheck",
                  value: function (e) {
                    var n = this.registrations[e];
                    return n ? t.register(e, n) : [];
                  },
                },
                {
                  key: "isRegistered",
                  value: function (t) {
                    return t.hasAttribute(ot);
                  },
                },
              ]),
              (n = [
                {
                  key: "replaceContainer",
                  value: function (t) {
                    this.container.removeAttribute(ot),
                      this.detatchEvents(this.container),
                      (this.container.innerHTML = t.innerHTML),
                      this.container.setAttribute(ot, "true"),
                      this.queryChildren(this.container),
                      this.init(),
                      this.attachEvents(this.container);
                  },
                },
                { key: "init", value: function () {} },
                {
                  key: "dispose",
                  value: function () {
                    this.container.removeAttribute(ot),
                      this.detatchEvents(this.container),
                      this.innerHtmlObserver &&
                        this.innerHtmlObserver.disconnect();
                  },
                },
              ]) && nt(e.prototype, n),
              i && nt(e, i),
              Object.defineProperty(e, "prototype", { writable: !1 }),
              t
            );
          })();
        function ct(t) {
          return (
            (ct =
              "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                ? function (t) {
                    return typeof t;
                  }
                : function (t) {
                    return t &&
                      "function" == typeof Symbol &&
                      t.constructor === Symbol &&
                      t !== Symbol.prototype
                      ? "symbol"
                      : typeof t;
                  }),
            ct(t)
          );
        }
        function st(t, e) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(t, dt(i.key), i);
          }
        }
        function ut(t, e) {
          return (
            (ut = Object.setPrototypeOf
              ? Object.setPrototypeOf.bind()
              : function (t, e) {
                  return (t.__proto__ = e), t;
                }),
            ut(t, e)
          );
        }
        function lt(t) {
          var e = (function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return (
                Boolean.prototype.valueOf.call(
                  Reflect.construct(Boolean, [], function () {})
                ),
                !0
              );
            } catch (t) {
              return !1;
            }
          })();
          return function () {
            var n,
              i = ht(t);
            if (e) {
              var r = ht(this).constructor;
              n = Reflect.construct(i, arguments, r);
            } else n = i.apply(this, arguments);
            return (function (t, e) {
              if (e && ("object" === ct(e) || "function" == typeof e)) return e;
              if (void 0 !== e)
                throw new TypeError(
                  "Derived constructors may only return object or undefined"
                );
              return ft(t);
            })(this, n);
          };
        }
        function ft(t) {
          if (void 0 === t)
            throw new ReferenceError(
              "this hasn't been initialised - super() hasn't been called"
            );
          return t;
        }
        function ht(t) {
          return (
            (ht = Object.setPrototypeOf
              ? Object.getPrototypeOf.bind()
              : function (t) {
                  return t.__proto__ || Object.getPrototypeOf(t);
                }),
            ht(t)
          );
        }
        function pt(t, e, n) {
          return (
            (e = dt(e)) in t
              ? Object.defineProperty(t, e, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (t[e] = n),
            t
          );
        }
        function dt(t) {
          var e = (function (t, e) {
            if ("object" !== ct(t) || null === t) return t;
            var n = t[Symbol.toPrimitive];
            if (void 0 !== n) {
              var i = n.call(t, e || "default");
              if ("object" !== ct(i)) return i;
              throw new TypeError(
                "@@toPrimitive must return a primitive value."
              );
            }
            return ("string" === e ? String : Number)(t);
          })(t, "string");
          return "symbol" === ct(e) ? e : String(e);
        }
        it(at, "registrations", {});
        var bt = "[data-making-process-main]",
          yt = "[data-page-accordion]",
          mt = "[data-accordion-slide]",
          vt = "[data-lightbox]",
          gt = document.querySelector(bt),
          St = (function (t) {
            !(function (t, e) {
              if ("function" != typeof e && null !== e)
                throw new TypeError(
                  "Super expression must either be null or a function"
                );
              (t.prototype = Object.create(e && e.prototype, {
                constructor: { value: t, writable: !0, configurable: !0 },
              })),
                Object.defineProperty(t, "prototype", { writable: !1 }),
                e && ut(t, e);
            })(o, t);
            var e,
              n,
              i,
              r = lt(o);
            function o() {
              var t;
              !(function (t, e) {
                if (!(t instanceof e))
                  throw new TypeError("Cannot call a class as a function");
              })(this, o);
              for (
                var e = arguments.length, n = new Array(e), i = 0;
                i < e;
                i++
              )
                n[i] = arguments[i];
              return (
                pt(
                  ft((t = r.call.apply(r, [this].concat(n)))),
                  "lightbox",
                  null
                ),
                pt(ft(t), "lightboxContent", null),
                pt(ft(t), "lightboxButtons", null),
                pt(ft(t), "closeButtons", null),
                pt(ft(t), "accordionElements", null),
                pt(ft(t), "accordions", []),
                t
              );
            }
            return (
              (e = o),
              (n = [
                {
                  key: "queryChildren",
                  value: function (t) {
                    (this.lightboxButtons = Array.from(
                      t.querySelectorAll("[data-lightbox-trigger]")
                    )),
                      (this.closeButtons = Array.from(
                        t.querySelectorAll("[data-lightbox-close]")
                      )),
                      (this.accordionElements = Array.from(
                        t.querySelectorAll(yt)
                      )),
                      this.initAccordion();
                  },
                },
                {
                  key: "initAccordion",
                  value: function () {
                    var t = this;
                    gt &&
                      gt.querySelector(yt) &&
                      (window.innerWidth >= l && this.openAllAccordions(),
                      window.addEventListener("resize", function () {
                        window.innerWidth < l
                          ? t.closeAllAccordions()
                          : t.openAllAccordions();
                      }));
                  },
                },
                {
                  key: "closeAllAccordions",
                  value: function () {
                    this.accordionElements &&
                      this.accordionElements.forEach(function (t) {
                        var e = t.querySelector(mt);
                        if (e) {
                          var n = e.closest(yt);
                          n &&
                            n.classList.contains(y) &&
                            (n.classList.remove(y), e.removeAttribute("open"));
                        }
                      });
                  },
                },
                {
                  key: "openAllAccordions",
                  value: function () {
                    this.accordionElements &&
                      this.accordionElements.forEach(function (t) {
                        var e = t.querySelector(mt);
                        if (e) {
                          var n = e.closest(yt);
                          n &&
                            (n.classList.add(y),
                            e.setAttribute("open", "open"));
                        }
                      });
                  },
                },
                {
                  key: "openLightbox",
                  value: function (t) {
                    try {
                      t.preventDefault();
                      var e = t.target.closest("[data-popup-container]");
                      if (!e) throw "Missing lightbox container";
                      if (
                        ((this.lightbox = e.querySelector(vt)),
                        (this.lightboxContent = e.querySelector(
                          "[data-lightbox-content]"
                        )),
                        !this.lightbox || !this.lightboxContent)
                      )
                        throw "Missing lightbox content";
                      (this.lightbox.visible = !0),
                        this.lightboxContent.scrollHeight >
                        this.lightboxContent.offsetHeight
                          ? this.lightbox.classList.add(m)
                          : this.lightbox.classList.remove(m);
                    } catch (t) {
                      console.warn(t);
                    }
                  },
                },
                {
                  key: "onLightboxClose",
                  value: function (t) {
                    try {
                      var e = t.target;
                      if (((this.lightbox = e.closest(vt)), !this.lightbox))
                        throw "Missing lightbox content";
                      this.lightbox.visible = !1;
                    } catch (t) {
                      console.warn(t);
                    }
                  },
                },
                {
                  key: "attachEvents",
                  value: function () {
                    var t = this;
                    this.closeButtons &&
                      this.closeButtons.forEach(function (e) {
                        e.addEventListener("click", function (e) {
                          return t.onLightboxClose(e);
                        });
                      }),
                      this.lightboxButtons &&
                        this.lightboxButtons.forEach(function (e) {
                          e.addEventListener("click", function (e) {
                            return t.openLightbox(e);
                          });
                        }),
                      this.accordionElements &&
                        this.accordionElements.forEach(function (e) {
                          t.accordions && t.accordions.push(new A(e));
                        });
                  },
                },
                {
                  key: "detatchEvents",
                  value: function () {
                    var t = this;
                    this.closeButtons &&
                      this.closeButtons.forEach(function (e) {
                        e.removeEventListener("click", t.onLightboxClose);
                      }),
                      this.lightboxButtons &&
                        this.lightboxButtons.forEach(function (e) {
                          e.removeEventListener("click", t.openLightbox);
                        }),
                      this.accordions &&
                        this.accordions.forEach(function (t) {
                          t.detachEvents();
                        });
                  },
                },
              ]) && st(e.prototype, n),
              i && st(e, i),
              Object.defineProperty(e, "prototype", { writable: !1 }),
              o
            );
          })(at);
        at.register(bt, St);
      },
      73234: function () {},
    },
    n = {};
  function i(t) {
    var r = n[t];
    if (void 0 !== r) return r.exports;
    var o = (n[t] = { exports: {} });
    return e[t].call(o.exports, o, o.exports, i), o.exports;
  }
  (i.m = e),
    (t = []),
    (i.O = function (e, n, r, o) {
      if (!n) {
        var a = 1 / 0;
        for (l = 0; l < t.length; l++) {
          (n = t[l][0]), (r = t[l][1]), (o = t[l][2]);
          for (var c = !0, s = 0; s < n.length; s++)
            (!1 & o || a >= o) &&
            Object.keys(i.O).every(function (t) {
              return i.O[t](n[s]);
            })
              ? n.splice(s--, 1)
              : ((c = !1), o < a && (a = o));
          if (c) {
            t.splice(l--, 1);
            var u = r();
            void 0 !== u && (e = u);
          }
        }
        return e;
      }
      o = o || 0;
      for (var l = t.length; l > 0 && t[l - 1][2] > o; l--) t[l] = t[l - 1];
      t[l] = [n, r, o];
    }),
    (i.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    })()),
    (i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (function () {
      var t = { 6933: 0 };
      i.O.j = function (e) {
        return 0 === t[e];
      };
      var e = function (e, n) {
          var r,
            o,
            a = n[0],
            c = n[1],
            s = n[2],
            u = 0;
          if (
            a.some(function (e) {
              return 0 !== t[e];
            })
          ) {
            for (r in c) i.o(c, r) && (i.m[r] = c[r]);
            if (s) var l = s(i);
          }
          for (e && e(n); u < a.length; u++)
            (o = a[u]), i.o(t, o) && t[o] && t[o][0](), (t[o] = 0);
          return i.O(l);
        },
        n = (self.webpackChunkto_ak = self.webpackChunkto_ak || []);
      n.forEach(e.bind(null, 0)), (n.push = e.bind(null, n.push.bind(n)));
    })(),
    i.O(void 0, [4736], function () {
      return i(68546);
    });
  var r = i.O(void 0, [4736], function () {
    return i(73234);
  });
  r = i.O(r);
})();

$(document).ready(function () {
  const makingContentBlock = $(
    ".c-making-process-main .c-making-process-main__content-block [data-accordion-slide]"
  );

  const updateOpenAttribute = () => {
    makingContentBlock.each(function (index) {
      const isOpen = $(this).attr("open") !== undefined;
      if (window.innerWidth >= 1100) {
        if (!isOpen) {
          $(this).attr("open", true);
        }
      } else {
        if (isOpen && index != 0) $(this).removeAttr("open");
      }
    });
  };

  updateOpenAttribute();
  $(window).resize(updateOpenAttribute);
});
